/** @param {{ dim?: boolean }} [opts] when `dim`, stroke is faint for hitbox-debug overlay mode */
export function drawAsteroid(ctx, ast, camera, opts = {}) {
  const dim = opts.dim === true
  let drawnCopies = 0
  camera.forEachVisibleCopy(ast.position.x, ast.position.y, ast.radius, (sx, sy) => {
    drawnCopies += 1
    ctx.save();
    ctx.translate(sx, sy);
    ctx.rotate(ast.rotation * Math.PI / 180);
    ctx.strokeStyle = dim ? 'rgba(255,255,255,.25)' : '#fff';
    ctx.lineWidth = 2;
    ctx.beginPath();
    const v = ast.vertices;
    ctx.moveTo(0, -ast.radius);
    for (let i = 1; i < v.length; i++) ctx.lineTo(v[i].x, v[i].y);
    ctx.closePath();
    ctx.stroke();
    ctx.restore();
  });
  return drawnCopies
}
